/* eslint-disable */
export default {
  saveLog: 'Speichern',
} as const;

// @key: @#@"saveLog"@#@ @source: @#@"Save"@#@
